import request from '@/config/axios'

export interface ExchangeCodeVO {
  id?: number
  code?: string
  batchNo?: string
  rewardType?: number
  rewardValue?: number
  couponTemplateId?: number
  status?: number
  validStartTime?: string
  validEndTime?: string
  userId?: number
  usedTime?: string
  remark?: string
  createTime?: string
}

export interface ExchangeCodeCreateBatchVO {
  rewardType: number
  rewardValue?: number
  couponTemplateId?: number
  generateCount: number
  batchNo?: string
  validStartTime: string
  validEndTime: string
  remark?: string
}

/** 权益：1券 2积分 */
export const EXCHANGE_REWARD_TYPE = { COUPON: 1, POINT: 2 } as const

/** 状态：0未用 1已用 2过期 4作废 */
export const EXCHANGE_CODE_STATUS = {
  UNUSED: 0,
  USED: 1,
  EXPIRED: 2,
  DISABLED: 4
} as const

export const ExchangeCodeApi = {
  getPage: async (params: any) => {
    return await request.get({ url: `/promotion/exchange-code/page`, params })
  },
  get: async (id: number) => {
    return await request.get({ url: `/promotion/exchange-code/get?id=` + id })
  },
  createBatch: async (data: ExchangeCodeCreateBatchVO) => {
    return await request.post({ url: `/promotion/exchange-code/create-batch`, data })
  },
  disable: async (id: number) => {
    return await request.put({ url: `/promotion/exchange-code/disable?id=` + id })
  },
  disableList: async (ids: number[]) => {
    return await request.put({ url: `/promotion/exchange-code/disable-list`, data: ids })
  }
}
